//@flow
import _ from 'lodash';
import * as React from 'react';
import { TableHeaderColumn } from 'react-bootstrap-table';
import connect from 'react-redux/es/connect/connect';
import ListagemPage from '../../components/templates/ListagemPage';
import { tableHelper } from '../../helpers/tableHelper';
import { userService } from '../../services/user.service';
import TopoTitleComponente from '../Topo/TopoTitleComponente';
import UsuarioCrudListFilter from './UsuarioCrudListFilter';

const endPoint = '/usuario/novo/';
const endPointView = '/usuario/';
class UsuarioCrudList extends React.PureComponent<{}, State> {
  constructor(props) {
    super(props);

    const isSudo = props.user && props.user.perfis.includes('SUDO');

    this.columns = [
      {
        path: 'nome',
        title: 'Nome',
        isKey: false,
        dataSort: false,
        className: 'txtBold',
      },
      {
        path: 'perfis',
        title: 'Perfis',
        isKey: false,
        dataSort: false,
        dataFormat: (cell, row) => {
          if (Array.isArray(row.perfis)) {
            return row.perfis.join(', ');
          }
          return '-';
        },
      },
      {
        path: 'cpf',
        title: 'CPF',
        isKey: true,
        dataSort: false,
      },
      ...(isSudo
        ? [
            {
              path: 'cliente.nomeFantasia',
              title: 'Cliente',
              isKey: false,
              dataSort: false,
            },
          ]
        : []),
    ];
    const fields = this.columns.map((col) => col.path);
    const labels = this.columns.map((col) => col.title);

    this.state = {
      labels,
      fields,
    };
  }

  handleRowClick = (row: e) => {
    console.log(row);
    let id = row.id;
    this.props.history.push(endPointView + id);
  };

  handleNewButton = (row: e) => {
    this.props.history.push(endPoint);
  };
  render() {
    const fields = this.state.fields;

    const tableColumn = _.map(this.columns, (column, index) => (
      <TableHeaderColumn
        key={index}
        dataField={column.path}
        dataFormat={tableHelper.renderCustom}
        formatExtraData={column}
        isKey={column.isKey}
        dataSort={column.dataSort}
        hidden={column.hidden}
        width={column.width}
        className={column.classname}
      >
        {column.title}
      </TableHeaderColumn>
    ));

    let filter = {
      extension: this.props.extension
        ? this.props.extension
        : this.props.user.extension,
    };

    return (
      <React.Fragment>
        <TopoTitleComponente
          mainTitle="Usuários"
          subTitle=" "
          canBack={false}
        />
        <ListagemPage
          newButtonActionClick={() => {
            this.props.history.push('/usuario/novo');
          }}
          delete={() => {}}
          service={userService}
          showNewButton={true}
          labelNewButton="Novo Usuario"
          defaultOrder={'nome'}
          defaultDirection={'asc'}
          defaultFilter={filter}
          onRowClick={this.handleRowClick}
          FormFilter={UsuarioCrudListFilter}
          fields={fields}
          array={'usuarios'}
        >
          {tableColumn}
        </ListagemPage>
      </React.Fragment>
    );
  }
}

function mapStateToProps(state) {
  const { user } = state.authentication;
  return {
    user,
  };
}

export default connect(mapStateToProps)(UsuarioCrudList);
